//エラーメッセージクリア//
 export function errClear(){
    let errMsg = document.querySelector('.alert_message');
    errMsg.textContent = '' ;
};
